import { render, staticRenderFns } from "./AddEditModal.vue?vue&type=template&id=f60e92dc"
import script from "./AddEditModal.vue?vue&type=script&lang=js"
export * from "./AddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports